export { default } from './HeadingBanner.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Text/HeadingBanner/index.js